import classNames from "classnames";
import React from "react";
import ReactTooltip from "react-tooltip";
import { GetSuggestionsFromB2FileInfos } from "source/app/presentation/Header/Tools/Sound/Music/CurrentSongInfo/GetSuggestions";
import { FormSelect } from "source/app/presentation/Shared/Form/Select/FormSelect";
import { StyleClassAuto } from "source/app/presentation/Shared/Styles/Auto/StyleClassAuto";
import AmbienceMenu from "../AmbienceMenu";
import { State } from "source/app/services/UI/State/State";
import { IAmbienceMenuState } from "../IAmbienceMenuState";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import Ambience from "source/app/services/Sound/Ambience/Ambience";
import { Sounds } from "source/app/services/Sound/Sounds";
import { AddStatusMessage } from "source/app/presentation/MainPanel/StatusBar/StatusBar";
import { EStatusMessageType } from "source/app/presentation/MainPanel/StatusBar/StatusMessageType/StatusMessageType";

export function CurrentAmbienceInfo({
    ambienceMenu,
}: {
    ambienceMenu: AmbienceMenu;
}) {
    const { currentFileInfo, allFileInfos } = ambienceMenu.state;

    if (!currentFileInfo) {
        return <div style={{ opacity: 0.5 }}>...</div>;
    }

    React.useEffect(() => {
        const statusMessage = `Ambience: ${fileNameWithoutExtension}`;
        AddStatusMessage(statusMessage, EStatusMessageType.info, 4000);

        ReactTooltip.rebuild();
    }, [currentFileInfo]);

    const { fileNameWithoutExtension } = currentFileInfo;

    return (
        <div>
            <FormSelect
                id="fileNameWithoutExtension"
                onChange={(event) => {
                    Sounds.electronic_tones_melodic_positive.Play();

                    State.ReadClass<IAmbienceMenuState>(
                        ESharedComponent.AmbienceMenu
                    ).setState({ selectedAmbience: event.target.value }, () => {
                        Ambience.Stop();
                        Ambience.StartNextAmbience();
                    });
                }}
                value={fileNameWithoutExtension}
                suggestions={GetSuggestionsFromB2FileInfos(
                    allFileInfos,
                    "fileNameWithoutExtension"
                )}
                classes={classNames(
                    StyleClassAuto({
                        opacity: 1,
                    }),
                    sharedStyleClass
                )}
                hideEmptyOption
            />
        </div>
    );
}

const sharedStyleClass = StyleClassAuto({
    width: `200px`,
    whiteSpace: `nowrap`,
    overflow: `hidden`,
    textOverflow: `ellipsis`,
    textAlign: `center`,
});
